export enum CommunitySection {
    openDiscussions = 1,
    mastermindCircles = 2
}